export const controlInitialState = {
    controls: undefined,
    events: undefined,
    members: undefined,
    error: undefined
}

export function controlReducer(state, action) {
    switch (action.type) {
        case 'FETCH':
            return { controls: action.controls, events: action.events, members: action.members, error: undefined }
        case 'SAVE': {
            const idx = state.controls.findIndex(c => c.uuid === action.control.uuid)
            const controls = idx >= 0
                ? state.controls.map(c => c.uuid === action.control.uuid ? action.control : c)
                : [...state.controls, action.control]
            return { ...state, controls, error: undefined }
        }
        case 'ERROR':
            return { ...state, error: action.error }
        default:
            return { ...state }
    }
}
